import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
//import Button from '@material-ui/core/Button';
import _ from 'lodash';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Transition from '../dialogs/Transition';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Zoom from '@material-ui/core/Zoom';

//import FormText from "../form/FormText";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
// import calendarConfig from '../../libs/calendarConfig';
//import FormCheckbox from "../form/FormCheckbox";

//- graphics
import CircularProgress from '@material-ui/core/CircularProgress';
import GreenChecked from '../../images/icons/greenChecked.svg';
import AuthUserContainer from '../../containers/AuthUser';
import FormComponent from '../FormComponent';
import SectionHeader from '../SectionHeader';
import FormDatePicker from '../form/FormDatePicker';
import UserAssignmentContainer from '../../containers/UserAssignment';
import ShiftSelect from '../advancedForm/ShiftSelect';
import FormTimePicker from '../form/FormTimePicker';
import UserScheduleTypeSelect from '../advancedForm/UserScheduleTypeSelect';
import UserSelect from '../advancedForm/UserPicker';
import { post } from '../../modules/utility';
import Note from '../Note';
import { getUserAssignmentTypeDisplay } from '../../libs/user';
import LocationSelect from '../advancedForm/LocationSelect';

function styles() {
	return {
		inner: {
			padding: '40px 30px',
		},
		dialogTitle: {
			fontSize: 30,
			borderBottom: '1px solid #eee',
			paddingBottom: 5,
			marginBottom: 10,
			fontWeight: 300,
			display: 'flex',
			justifyContent: 'space-between',
		},
		noNotes: {
			color: '#999',
			textTransform: 'italic',
		},
		dateNote: {
			color: '#666',
			fontSize: 14,
		},
		noteContainer: {
			paddingBottom: 5,
			borderBottom: '1px solid #f5f5f5',
			marginBottom: 5,
		},
		badgeMargin: {
			paddingRight: 10,
		},
		noteBadge: {
			backgroundColor: '#00BCD4',
		},
		activityBadge: {
			backgroundColor: '#9C27B0',
		},
		dialogRoot: {
			//overflow: 'visible'
			//alignItems: 'end',
		},
		closeButton: {
			position: 'absolute',
			right: 15,
			top: 15,
			color: '#555',
		},
		addButton: {
			//verticalAlign : 'middle',
			//textDecoration: 'none',
			//marginBottom: 0,
			//borderRadius: 100,
			padding: '10px 35px',
			fontSize: 16,
			marginTop: 20,
		},
		greenCheckedIcon: {
			display: 'inline-block',
			width: 24,
			height: 24,
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 5,
			marginLeft: 5,
		},
		isSaving: {
			marginLeft: 20,
			fontSize: 16,
			color: '#1565C0',
		},
		savingSuccessful: {
			marginLeft: 20,
			fontSize: 16,
			color: '#2E7D32',
		},
		truckSection: {
			fontSize: '120%',
			display: 'flex',
			alignItems: 'space-between',
			marginTop: 10,
		},
		label: {
			paddingRight: 3,
		},
		value: {
			fontWeight: 700,
			color: '#555',
			paddingRight: 25,
		},
		shiftDot: {
			fontWeight: 700,
			color: '#555',
			borderRadius: '15px',
			width: 15,
			height: 15,
			display: 'inline-block',
			margin: 2,
			marginBottom: 6,
			verticalAlign: 'middle',
		},
	};
}

class AddUserAssignmentDialog extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			formFieldError: {},
			isSaving: false,
			savingSuccessful: false,
			startDate: moment().format('YYYY-MM-DD'),
			shiftTime: moment().hour(9).minute(0).format('YYYY-MM-DD HH:mm'),

			isFindingCurrent: false,
			currentAssignmentResponse: undefined,
		};
	}

	componentDidUpdate(prevProps, prevState, _snapshot) {
		const { userAssignmentTypeId, locationId } = this.props;
		const { userId } = this.state;

		if (userAssignmentTypeId && userAssignmentTypeId !== prevProps.userAssignmentTypeId) {
			this.setState({
				userAssignmentTypeId,
			});
		}

		if (locationId && locationId !== prevProps.locationId) {
			this.setState({
				locationId,
			});
		}

		if (userId && userId !== prevState.userId) {
			this.findCurrent({ userId });
		}
	}

	findCurrent = ({ userId }) => {
		this.setState({ isFindingCurrent: true });
		post({
			method: 'userAssignment.findCurrent',
			params: {
				userId,
			},
			callback: (err, r) => {
				if (err) {
					this.setState({ isFindingCurrent: false, currentAssignmentResponse: undefined });
					this.props.showErrors(err);
					return;
				}
				_.delay(() => {
					this.setState({
						isFindingCurrent: false,
						currentAssignmentResponse: r,
					});
				}, 500);
			},
		});
	};

	handleAdd = () => {
		const { showErrors, addUserAssignment, onRefreshData } = this.props;

		const formFieldError = {};
		[
			{ path: 'userId', label: 'User' },
			{ path: 'startDate', label: 'Start Date' },
			{ path: 'shiftId', label: 'Shift' },
			{ path: 'locationId', label: 'Location' },

			{
				path: 'shiftTime',
				label: 'Shift Time',
			},
			{
				path: 'shiftTime',
				label: 'Shift Time',
			},
			{
				path: 'userAssignmentTypeId',
				label: 'Schedule Routine',
			},
		].forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		this.setState({ isSaving: true, savingSuccessful: false });

		const { shiftId, shiftTime, userAssignmentTypeId, userId, startDate, locationId } = this.state;
		addUserAssignment({
			params: {
				userId,
				startDate,
				locationId,
				shiftId,
				shiftTime: moment(shiftTime).format('HH:mm'),
				userAssignmentTypeId,
			},
			callback: (err) => {
				if (err) {
					this.setState({ isSaving: false });
					showErrors(err);
					return;
				}

				_.delay(() => {
					this.setState({
						isSaving: false,
						savingSuccessful: true,
					});

					onRefreshData();
					_.delay(() => {
						this.setState({ savingSuccessful: false });
					}, 2000);
				}, 400);
			},
		});
	};

	render() {
		const { open, onClose, classes } = this.props;

		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={onClose}
				fullWidth={true}
				maxWidth={'md'}
				classes={{ scrollPaper: classes.dialogRoot }}
			>
				{this.renderBody()}
			</Dialog>
		);
	}

	renderBody = () => {
		const { onClose, classes } = this.props;
		const { isSaving, savingSuccessful, locationId } = this.state;

		return (
			<div className={classes.inner}>
				<div className={classes.dialogTitle}>
					<div>Add User To Schedule</div>
					<div>
						<IconButton className={classes.closeButton} onClick={onClose}>
							<CloseIcon />
						</IconButton>
					</div>
				</div>
				<Grid container spacing={2}>
					<UserSelect
						{...this.setForm('userId', 'User', true)}
						whoToShow={'driversAndNonDriversOnly'}
					/>

					<Grid item xs={12}>
						<div style={{ border: '1px solid #ddd', padding: 15 }}>
							{this.renderCurrentAssignment()}
						</div>
					</Grid>
				</Grid>
				<Grid container spacing={2} style={{ alignItems: 'center' }}>
					<Grid item xs={12} style={{ marginTop: '15px', paddingBottom: 0 }}>
						<SectionHeader label={'Schedule Info'} isTop={true} />
					</Grid>

					<Grid item sm={4}>
						<LocationSelect {...this.setForm('locationId', 'Pick Location', true)} />
					</Grid>

					<Grid item sm={4}>
						<ShiftSelect {...this.setForm('shiftId', 'Day / Night Shift', true)} />
					</Grid>
					<FormTimePicker
						{...this.setForm('shiftTime', 'Shift Start Time')}
						minutesStep={5}
						//format={'HH:mm'}
						gridProps={{ sm: 4 }}
					/>
				</Grid>
				<Grid container spacing={2} style={{ alignItems: 'center' }}>
					<Grid item xs={12} style={{ marginTop: '15px', paddingBottom: 0 }}>
						<SectionHeader label={'Routine and Start Date'} isTop={true} />
					</Grid>

					<Grid item xs={12} md={6}>
						<UserScheduleTypeSelect
							{...this.setForm('userAssignmentTypeId', 'Schedule Routine', true)}
							selectedLocationId={parseInt(locationId, 10)}
						/>
					</Grid>

					<FormDatePicker
						{...this.setForm('startDate', 'Start Date')}
						gridProps={{ xs: 12, md: 6 }}
					/>
				</Grid>
				<Grid container spacing={2}>
					<Grid item md={12} style={{ display: 'flex', alignItems: 'baseline' }}>
						<Button
							variant="contained"
							color="primary"
							className={classes.addButton}
							onClick={this.handleAdd}
							disabled={isSaving}
						>
							Add User To Schedule
						</Button>

						<Zoom
							in={isSaving}
							style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
							mountOnEnter
							unmountOnExit
						>
							<div className={classes.isSaving}>
								<CircularProgress style={{ verticalAlign: 'middle' }} />
								<span style={{ paddingLeft: 10 }}>Saving...</span>
							</div>
						</Zoom>

						<Zoom
							in={savingSuccessful}
							style={{ transitionDelay: savingSuccessful ? '250ms' : '0ms' }}
						>
							<div className={classes.savingSuccessful}>
								<div className={classes.greenCheckedIcon} />
								<span style={{ paddingLeft: 10 }}>Save Successful.</span>
							</div>
						</Zoom>
					</Grid>
				</Grid>
			</div>
		);
	};

	renderCurrentAssignment = () => {
		const { classes } = this.props;
		const { isFindingCurrent, currentAssignmentResponse } = this.state;

		if (isFindingCurrent) {
			return (
				<div className={classes.isUploading}>
					<CircularProgress size="1rem" />
					<span style={{ marginLeft: 5 }}>Finding current assignment</span>
				</div>
			);
		}

		if (!currentAssignmentResponse) {
			return (
				<div style={{ color: '#999' }}>
					Select a user to see their current assignment on the schedule
				</div>
			);
		}

		const {
			userAssignmentCollection,
			locationCollection,
			shiftCollection,
		} = currentAssignmentResponse.collections;

		if (_.isEmpty(userAssignmentCollection)) {
			return (
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<div className={classes.greenCheckedIcon} />
					<span>User is not currently scheduled at any locations and its ready to be added.</span>
				</div>
			);
		}

		const locationMap = _.keyBy(locationCollection, 'locationId');
		const shiftMap = _.keyBy(shiftCollection, 'shiftId');

		return (
			<div>
				<Note>
					User is currently on the schedule already. You can add a new assignment for them, but it
					will end their current assignment with the end date being this assignments start date.
				</Note>

				{userAssignmentCollection.map((ua) => {
					const {
						locationId,
						shiftId,
						userAssignmentTypeId,
						startDate,
						shiftTime,
						userAssignmentId,
					} = ua;
					const locationDisplay = locationMap[locationId]
						? locationMap[locationId].display
						: 'Missing';

					const shiftDisplay = shiftMap[shiftId] ? shiftMap[shiftId].display : 'Missing';

					return (
						<div key={userAssignmentId}>
							<div>
								<strong>Location:</strong> {locationDisplay}
							</div>
							<div>
								<strong>Shift:</strong> {shiftDisplay} (@ {shiftTime})
							</div>
							<div>
								<strong>Schedule Type:</strong>{' '}
								{getUserAssignmentTypeDisplay({ userAssignmentTypeId })}
							</div>
							<div>
								<strong>Start Date:</strong> {moment(startDate).format('ddd M/D')}
							</div>
						</div>
					);
				})}
			</div>
		);
	};
}

AddUserAssignmentDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	data: PropTypes.object,
	userAssignmentTypeId: PropTypes.string,
	locationId: PropTypes.number,
	addUserAssignment: PropTypes.func.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	UserAssignmentContainer,
])(AddUserAssignmentDialog);
